// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.full-page-loader-wrapper {
  width: 100vw;
  height: 100vh;
  background-color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
}
.full-page-loader-wrapper > div {
  position: relative;
}
.full-page-loader-wrapper > div > div {
  position: absolute;
  width: 68px;
  height: 68px;
  left: -11px;
  top: -15px;
  border-radius: 50%;
  border: 2px solid #92278F;
  border-bottom: 1px solid transparent;
  animation: rotateBorder 2s linear infinite;
}`, "",{"version":3,"sources":["webpack://./src/components/FullPageLoader/FullPageLoader.scss"],"names":[],"mappings":"AAAA;EACI,YAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AACJ;AACI;EACI,kBAAA;AACR;AACM;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,UAAA;EACA,kBAAA;EACA,yBAAA;EACA,oCAAA;EACA,0CAAA;AACR","sourcesContent":[".full-page-loader-wrapper{\n    width: 100vw;\n    height: 100vh;\n    background-color: #fff;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n\n    >div{\n        position: relative;\n      \n      >div{\n        position: absolute;\n        width: 68px;\n        height: 68px;\n        left: -11px;\n        top: -15px;\n        border-radius: 50%;\n        border: 2px solid #92278F;\n        border-bottom: 1px solid transparent;\n        animation: rotateBorder 2s linear infinite;\n      }\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
